import axios from '../../axios'

export function webInitialization() {
  return async (dispatch) => {
    try {
      dispatch({ type: 'WEB_INITIALIZATION_PENDING' })

      const res = await axios.get('Webs/initialization')
      const { statistics, user, zones, sessions, actives } = res.data
      const {
        marshals_online: marshalsOnline,
        reports_new: reportsNew,
        reports_today: reportsToday,
        summons_new: summonsNew,
        summons_today: summonsToday,
        tours_today: toursToday,
      } = statistics

      dispatch({
        type: 'WEB_INITIALIZATION_FULFILLED',
        payload: {},
      })

      dispatch({
        type: 'SESSION_ONLINE_COUNT',
        payload: {
          data: { sessions, marshalsOnline },
          error: null,
        },
      })
      dispatch({
        type: 'REPORTS_STATISTICS_COUNT',
        payload: {
          data: { reports_new: reportsNew, reports_today: reportsToday },
          error: null,
        },
      })
      dispatch({
        type: 'SUMMONS_STATISTICS_COUNT',
        payload: {
          data: { summons_new: summonsNew, summons_today: summonsToday },
          error: null,
        },
      })
      dispatch({
        type: 'TOURS_STATISTICS_COUNT',
        payload: {
          data: toursToday,
          error: null,
        },
      })

      dispatch({
        type: 'ENDUSER_ONLINE_INFO',
        payload: {
          data: user,
          error: null,
        },
      })
      dispatch({
        type: 'ZONES_INFO_INIT',
        payload: {
          data: zones,
          error: null,
        },
      })

      dispatch({
        type: 'TRACKERS_ACTIVES_INIT',
        payload: {
          data: { actives },
          error: null,
        },
      })
    } catch (e) {
      console.error(e)
      dispatch({
        type: 'WEB_INITIALIZATION_REJECTED',
        payload: {
          response: null,
          error: {
            message: e.message,
            name: e.name,
          },
        },
      })
    }
  }
}
